import styled from 'styled-components';
import img1 from './images/SRS_2487.png';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ImMail2 } from 'react-icons/im';
import {
  breakpoints,
  colors,
  Divider,
  DividerDiamond,
  Page,
} from '../styles/theme';

const Header = styled.div`
  text-align: center;
  margin-bottom: 56px;

  h1 {
    font-size: 42px;
    color: ${colors.accent};
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 0.14em;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 32px;
    }
  }
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(300px, 420px);
  gap: 64px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 44px;
    max-width: 620px;
    margin: 0 auto;
  }
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  font-size: 16.5px;
  line-height: 1.85;
  text-align: justify;
  padding-top: 8px;
`;

const ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

const Portrait = styled.img`
  width: 100%;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  box-shadow: 0 18px 40px rgba(42, 30, 21, 0.18);
`;

const ContactCard = styled.div`
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  border-top: 3px solid ${colors.gold};
  padding: 30px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 12px 30px rgba(42, 30, 21, 0.07);
`;

const ContactLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: ${colors.ink};
  text-decoration: none;
  font-size: 15px;
  letter-spacing: 0.02em;
  transition: color 0.2s ease;

  svg {
    color: ${colors.gold};
    flex: none;
  }

  &:hover {
    color: ${colors.accent};
    text-decoration: underline;
    text-underline-offset: 4px;
    text-decoration-color: ${colors.gold};
  }
`;

export function Contact() {
  return (
    <Page>
      <Header>
        <h1>hafðu samband</h1>
        <Divider>
          <DividerDiamond />
        </Divider>
      </Header>
      <ContactGrid>
        <TextColumn>
          <p>
            Ég tek að mér prófarkarlestur á hvers kyns textum; fræðilegum, hversdagslegum og skáldlegum. Ég hef BA gráðu í íslensku og MA í ritlist.
          </p>
          <p>
            Ég tek tillit til stafsetningar, málfræði, flæðis, stíls og samræmis. Ég hef tekið að mér yfirlestr á lokaritgerðum, hvoru tveggja til BA- eða MA-gráðu, en hef einnig mikla reynslu af yfirferð skáldtexta, hvort sem það eru prósa- eða ljóðatextar. Ég er mjög vandvirk og nákvæm og fer vel yfir heimildir.
          </p>
          <p>
            Einnig má hafa samband við mig fyrir smærri eða annars konar verkefni, svo sem ráðgjöf, ritstjórn eða þýðingar.
          </p>
        </TextColumn>
        <ImageColumn>
          <Portrait src={img1} alt="Birgitta Björg Guðmarsdóttir" />
          <ContactCard>
            <ContactLink href="mailto:birgittabjorg98@gmail.com">
              <ImMail2 fontSize={20} />
              birgittabjorg98@gmail.com
            </ContactLink>
            <ContactLink href="https://facebook.com">
              <FontAwesomeIcon fontSize={20} icon={faFacebook} />
              Birgitta Björg Guðmarsdóttir
            </ContactLink>
            <ContactLink href="https://instagram.com">
              <FontAwesomeIcon fontSize={20} icon={faInstagram} />
              @stjornuljosa
            </ContactLink>
          </ContactCard>
        </ImageColumn>
      </ContactGrid>
    </Page>
  );
}
